import React, { useCallback, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchProfilePhotoUrl } from "../../../redux/context/actions";
const UserProfileAvatar = () => {
    var _a, _b;
    const dispatch = useDispatch();
    const context = useSelector((state) => state.context);
    const retriedRef = useRef(false);
    const currentUrl = (context === null || context === void 0 ? void 0 : context.profilePhotoUrl) || "";
    const handleAvatarError = useCallback(() => {
        if (retriedRef.current)
            return true;
        retriedRef.current = true;
        dispatch(fetchProfilePhotoUrl(true));
        return true;
    }, [dispatch]);
    useEffect(() => {
        retriedRef.current = false;
    }, [currentUrl]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "item settings-user" },
            React.createElement("div", { className: "settings-user__text" },
                React.createElement("strong", { className: "settings-user__name" }, (_a = context === null || context === void 0 ? void 0 : context.userFullName) !== null && _a !== void 0 ? _a : ""),
                React.createElement("div", { className: "settings-user__role" }, (_b = context === null || context === void 0 ? void 0 : context.profession) !== null && _b !== void 0 ? _b : "")))));
};
export default UserProfileAvatar;
